import { render } from "./RecipeView.vue?vue&type=template&id=a7a879be&scoped=true"
import script from "./RecipeView.vue?vue&type=script&lang=js"
export * from "./RecipeView.vue?vue&type=script&lang=js"

import "./RecipeView.vue?vue&type=style&index=0&id=a7a879be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7a879be"]])

export default __exports__